import React from "react";
import PropTypes from "prop-types";
import { InputGroup, FormControl, FormLabel, FormGroup } from "react-bootstrap";

const DollarValueInput = React.forwardRef((props, ref) => {
  return (
    <FormGroup>
      <FormLabel>{props.label}</FormLabel>
      <InputGroup>
        <InputGroup.Prepend>
          <InputGroup.Text>$</InputGroup.Text>
        </InputGroup.Prepend>
        <FormControl
          ref={ref}
          defaultValue={props.value || 0.0}
          onChange={props.onChange}
        ></FormControl>
      </InputGroup>
    </FormGroup>
  );
});

DollarValueInput.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired
};

export default DollarValueInput;
